import type { Dispatch } from "redux";
import actions from "~/shared/actions";
import * as server from "~/shared/api/server";
import type { ArchivedRecommendation, Policy } from "~/shared/reducers/policies";
import type { VeiledningsSvar } from "~/utils/kartlegging";

export function loadRisikovurdering(productId: string, age?: number) {
	return (dispatch) => {
		dispatch(actions.loadRisikovurderingRequest({ productId }));
		return Promise.all([server.getRisikovurdering(age), server.getRisikomapping(productId, age)]).then(([sporsmal, mapping]) =>
			dispatch(
				actions.loadRisikovurderingResponse({
					mapping,
					productId,
					sporsmal,
				}),
			),
		);
	};
}

export function saveRecommendation(polisenummer: Policy["polisenummer"], data: ArchivedRecommendation) {
	return (dispatch) => {
		dispatch(actions.saveRecommendationRequest({ polisenummer, result: data }));
		return server.saveRecommendation(polisenummer, data).then(() => dispatch(actions.saveRecommendationResponse({ polisenummer, result: data })));
	};
}

export function archiveRisikovurdering(polisenummer: number, data: VeiledningsSvar[]) {
	return (dispatch) => {
		dispatch(actions.archiveRisikovurderingRequest({ polisenummer, data }));
		server.archiveRisikovurdering(polisenummer, data);
	};
}

export function answerRisikovurdering(data) {
	return (dispatch) => dispatch(actions.risikovurderingComplete(data));
}

export function setProfileSelection(data) {
	return (dispatch: Dispatch) => dispatch(actions.setProfileSelection(data));
}

export function resetRisikovurdering() {
	return (dispatch) => dispatch(actions.resetRisikovurdering());
}

export function ignoreArchivedRisikovurdering(polisenummer) {
	return (dispatch) => dispatch(actions.ignoreArchivedRisikovurdering({ polisenummer }));
}
